<template>
  <el-container>
    <el-header class="my-header" height="25vh">
      <h1 style="font-size: xx-large">知识产权综合服务平台</h1>
      <img src="../assets/logo.png" alt="logo" style="width: 300px;height: auto;max-width: 100%;margin: 0 auto;">
    </el-header>
    <el-main>
      <el-row class="el-row" type="flex" justify="center">
        <el-col :span="8">
          <el-button class="home-btn" type="primary" @click="$router.push('/add')">新增公司</el-button>
        </el-col>
        <el-col :span="8">
          <el-button class="home-btn" type="primary" @click="$router.push('/search')">查询</el-button>
        </el-col>
      </el-row>
      <el-row class="el-row" type="flex" justify="center">
        <el-col :span="8">
          <el-button class="home-btn" type="primary" @click="$router.push('/edit')">修改</el-button>
        </el-col>
        <el-col :span="8">
          <el-button class="home-btn" type="primary" @click="$router.push('/close')">封存</el-button>
        </el-col>
      </el-row>
      <el-row class="el-row" type="flex" justify="center">
        <el-col :span="8">
          <el-button class="home-btn" type="primary" @click="$router.push('/warn')">到期提醒</el-button>
        </el-col>
        <el-col :span="8">
          <el-button class="home-btn" type="primary" @click="close()">关闭</el-button>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
export default {
  created () {
    if (!sessionStorage.getItem('jId')) {
      this.$router.push('/login').then()
    }
  },
  methods: {
    close: function () {
      this.$confirm('确认退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.removeItem('jId')
        this.$router.push('/login').then()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.my-header {
  display: flex;
  flex-direction: column-reverse;
  text-align: center;
}
.el-row {
  margin-bottom: 50px;
  text-align: center;
  &:last-child {
    margin-bottom: 0;
  }
}
.home-btn{
  width: 200px;
  max-width: 100%;
  height: 100px;
  max-height: 100%;
  font-size: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue